import {checkNull} from '@/helpers'

export default {
    name: 'custom-page',
    data() {
        return {
            title: '',
            content: '',
            page_slug: '',
            city_images: [],
            page: {},
            show_not_found: false,
        }
    },
    metaInfo () {
        if(this.show_not_found) {
            return {
                title: `404 ${this.$t('page not found')}`
            }
        }

        let meta = {
            title: this.page.meta_title,
            meta: [
                { vmid: 'description', name: 'description', content: this.page.meta_description || '' },
                { vmid: 'keywords', name: 'keywords', content: this.page.meta_keywords || '' },
            ]
        }
        if(this.page.canonical_url) {
            let url = this.page.canonical_url;
            let pattern = new RegExp('^(https?|ftp)://');
            if(!pattern.test(url)) {
                url = window.location.origin + '/' + url.replace(/^\//g, '');
            }
            meta.link = [
                { vmid: 'canonical', rel: 'canonical', href: url }
            ];
        }
        return meta;
    },
    methods: {
        loadData() {
            this.page_slug = checkNull(this.$route.name) ? this.$route.name : this.page_name
            this.$store.dispatch('pub/getPage', this.$t(this.page_name))
                .then(res => {
                    if(typeof res.data != 'object') {
                        this.show_not_found = true
                    } else {
                        this.page = res.data;
                        this.title = res.data.title
                        this.content = res.data.text
                        this.city_images = res.data.city_images
                    }
                }, res => {
                    this.show_not_found = true
                })
        }
    },
    props: {
        page_name: {
            type: String,
            default: ''
        },
        is_not_found: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if(this.is_not_found) {
            this.show_not_found = this.is_not_found
        } else {
            this.loadData()
        }
    },
    watch: {
        '$route' (to, from) {
            this.loadData()
        }
    }
}
